/**
 * DB enums are SCREAMING_SNAKE; humans read "Screaming Snake". One helper so every chip and cell
 * shows the same humanized label while the underlying value stays exactly what the DB holds.
 */
export const humanizeEnum = (value: string | null | undefined): string => {
    if (!value) return '—';
    return value
        .split('_')
        .map((w) => (w.length ? w.charAt(0).toUpperCase() + w.slice(1).toLowerCase() : w))
        .join(' ');
};
